const Actions = {
  SET_ANALYTICS_CONFIG: 'YouVisitAnalytics.Actions.SET_ANALYTICS_CONFIG',
};

export default Actions;
